module.exports = __webpack_public_path__ + "static/service-hand-bg-1-1-20a2f93e3884d34cdd5b95e510f3c2ff.png";